import { Box, Grid, Tab, Tabs, Typography } from '@mui/material'
import InputCustom from '../../atoms/input/InputCustom'
import ButtonCustom from '../../atoms/button/ButtonCustom'

import styles from './index.module.scss'

function CustomTabPanel(props) {
	const { children, value, index, ...other } = props

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`vendor-dashboard-tabpanel-${index}`}
			aria-labelledby={`vendor-dashboard-tab-${index}`}
			{...other}
		>
			{value === index && <Box>{children}</Box>}
		</div>
	)
}

export default function InnerTab({
	dataList,
	dataGrid,
	innerTab,
	handleChangeListCalendar,
	...props
}) {
	const innerTabStyle = {
		'&.MuiTabs-root': {
			minHeight: 'unset',
			backgroundColor: '#F2F6F8',
			padding: '2px 4px',
			borderRadius: '10px',
		},
		'& .MuiTabs-scroller': {
			padding: '0',
		},

		'& .MuiButtonBase-root': {
			padding: '6px 8px',
			minHeight: 'unset',
			fontSize: '14px',
			fontFamily: 'Inter',
			fontWeight: '500',
			color: '#8692A4',
			textTransform: 'capitalize',
			minWidth: ' auto !important',

			'&.Mui-selected': {
				color: '#7CA6BD',
				backgroundColor: '#fff',
				borderRadius: '8px',
				boxShadow: '0px 1px 3px 0px #0000001A',
				minWidth: ' auto !important',

				'& svg path': {
					stroke: '#7CA6BD',
				},
			},
		},
		'& .MuiTabs-indicator': {
			backgroundColor: 'transparent',
		},
		'@media (max-width: 599px)': {
			'& .MuiButtonBase-root': {
				padding: '6px 8px',
			},
		},
	}
	return (
		<>
			<Box sx={{ width: '100%' }} className={styles.mainTabs}>
				<Box className={styles.topRow}>
					{/* {ProposalCardBidData} */}
					<Grid container spacing={2}>
						<Grid size={{ xs: 12, sm: 4, md: 2.4 }}>
							<div className={styles.searchContainer}>
								<InputCustom
									type="text"
									name="search"
									id="search"
									placeholder="Search Payment"
									error={false}
									searchIcon={true}
									value={props.searchQuery || ''}
									onChange={(e) =>
										props.onSearchChange?.(e.target.value)
									}
								/>
							</div>
						</Grid>
						<Grid size={{ xs: 12, sm: 8, md: 9.6 }}>
							<div className={styles.ctaRow}>
								<div className={styles.filterBtns}>
									<div className={styles.left}>
										<Tabs
											value={innerTab}
											onChange={handleChangeListCalendar}
											aria-label="basic tabs example"
											sx={innerTabStyle}
										>
											<Tab
												label={
													<div
														className={`${styles.tabItem} ${innerTab === 0 ? styles.selected : ''}`}
													>
														<img
															src="/images/Grid.svg"
															alt="Grid"
														/>
														<span>Grid</span>
													</div>
												}
											/>
											<Tab
												label={
													<div
														className={`${styles.tabItem} ${innerTab === 1 ? styles.selected : ''}`}
													>
														<img
															src="/images/List.svg"
															alt="List"
														/>
														<span>List</span>
													</div>
												}
											/>
										</Tabs>
									</div>
									<div className={styles.rightActions}>
										<ButtonCustom
											variant="outlined"
											onClick={props.onClickFilter}
											size="small"
											style={{
												minHeight: '40px',
											}}
										>
											<img src="/images/filter.svg" />
											<Typography variant="body">
												Filter
											</Typography>
										</ButtonCustom>
									</div>
								</div>
							</div>
						</Grid>
					</Grid>
				</Box>
				<CustomTabPanel
					value={innerTab}
					index={0}
					className={styles.TaskTimeLineDataGrid}
				>
					{dataGrid}
				</CustomTabPanel>
				<CustomTabPanel
					value={innerTab}
					index={1}
					className={styles.TaskTimeLineDataGrid}
				>
					{dataList}
				</CustomTabPanel>
			</Box>
		</>
	)
}
